import { useMutation, useQueryClient } from "@tanstack/react-query";

import { client } from "@/config/client";

export const useCreateRevision = function (id, invalidateKeys) {
  const queryClient = useQueryClient();

  const mutationFn = (data) => {
    return client["interventionTemplates"].revision(id, data);
  };

  const onSuccess = () => {
    invalidateKeys?.forEach((queryKey) =>
      queryClient.invalidateQueries({ queryKey })
    );
  };

  return useMutation({
    mutationFn,
    onSuccess,
  });
};
